/* Artist-aware storefront navigation. Does not replace, push or intercept browser history. */
(function () {
  'use strict';
  const c = window.XDropArtistConfig || {};
  const root = (c.root || '/').replace(/\/?$/, '/');
  const home = root + 'pages/karol-g';
  const ids = new Set((c.karolIds || []).map(String));
  const key = 'xdrop-active-artist-v1';
  function getStored(){try{return sessionStorage.getItem(key);}catch(_){return null;}}
  function pathOf(url){return url.pathname.replace(/\/$/, '') || '/';}
  function resolve(url, ref, stored) {
    const p = pathOf(url), r = root.replace(/\/$/,'') || '/';
    // An explicit artist entry always wins over a previous tab session.
    if (p === r || p === '/') return 'bad-bunny';
    if (p === home) return 'karol-g';
    // Actual product ownership wins over query strings and stale cart context.
    if (c.productId) return ids.has(String(c.productId)) ? 'karol-g' : 'bad-bunny';
    if (url.searchParams.get('artist') === 'karol-g') return 'karol-g';
    if (url.searchParams.get('artist') === 'bad-bunny') return 'bad-bunny';
    if (ref && ref.origin === url.origin && pathOf(ref) === home) return 'karol-g';
    if (stored === 'karol-g' || stored === 'bad-bunny') return stored;
    const items = c.cartProductIds || [];
    return items.length && items.every(id => ids.has(String(id))) ? 'karol-g' : 'bad-bunny';
  }
  let ref;try{ref = document.referrer ? new URL(document.referrer) : null;}catch(_){}
  const artist = resolve(new URL(location.href), ref, getStored());
  document.documentElement.dataset.xdropArtist = artist;
  try{sessionStorage.setItem(key,artist);}catch(_){}
  window.XDropArtist = {artist,home};
  addEventListener('pageshow',function(){try{sessionStorage.setItem(key,artist);}catch(_){}});
  if (artist !== 'karol-g') return;
  function setHref(a,value){if(a.getAttribute('href')!==value)a.setAttribute('href',value);}
  function apply() {
    document.querySelectorAll('a[href]').forEach(a => {
      const raw=a.getAttribute('href');if(!raw || raw.startsWith('#'))return;
      let u;try{u=new URL(raw,location.href);}catch(_){return;}
      if(u.origin!==location.origin)return;
      const p=pathOf(u), r=root.replace(/\/$/,'') || '/';
      if(p===r || p==='/' || p===root+'collections/all'){
        setHref(a,home);
        if(a.closest('.kg-footer') && /Bad Bunny/i.test(a.textContent)){
          a.textContent=document.documentElement.lang==='en'?'Back to collection':'Volver a la colección';
        }
      } else if(p===root+'cart' || p.startsWith(root+'cart/') || p.startsWith(root+'products/') || p.startsWith(root+'policies/')) {
        u.searchParams.set('artist','karol-g');setHref(a,u.pathname+u.search+u.hash);
      }
    });
    // Global theme header is hidden because it may contain other-artist navigation.
    if(!document.querySelector('.kg-shell,xb-cart,.xdrop-artist-nav')) {
      const nav=document.createElement('nav');nav.className='xdrop-artist-nav';nav.setAttribute('aria-label','Karol G');
      const link=document.createElement('a');link.href=home;link.textContent='THE X DROP';
      const small=document.createElement('small');small.textContent='KAROL G';link.appendChild(small);
      const cart=document.createElement('a');cart.href=root+'cart?artist=karol-g';cart.textContent=document.documentElement.lang==='en'?'Cart':'Carrito';
      nav.append(link,cart);document.body.prepend(nav);
    }
  }
  function ready(){apply();new MutationObserver(apply).observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
  // Safari bfcache restores real history; only refresh navigation labels/links.
  addEventListener('pageshow',apply);
})();
